import { Styles, css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import DocumentSearchIcon from '../icon/generated/DocumentSearchIcon';

interface Props {
  description?: string;
  css?: Styles;
}

export const NoData = ({ description, css: cssProps }: Props) => {
  return (
    <div
      className={css(
        center.raw({
          textStyle: 'Text/S/Regular',
          color: 'content.default.level-3',
          flexDirection: 'column',
          w: '100%',
          py: 120,
          px: 12,
          gap: 8,
        }),
        cssProps,
      )}
    >
      <DocumentSearchIcon />
      <p>{description || 'No data found'}</p>
    </div>
  );
};
